"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLink = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importStar(require("styled-components"));
var breakpoints_1 = require("../../style/breakpoints");
var colors_1 = __importDefault(require("../../style/colors"));
var mixins_1 = require("../../style/mixins");
var mapValues_1 = __importDefault(require("../../util/mapValues"));
var sizes = {
    10: {
        fontSize: 10,
        lineHeight: 18,
        letterSpacing: 0.01
    },
    12: {
        fontSize: 12,
        lineHeight: 18,
        letterSpacing: 0.01
    },
    14: {
        fontSize: 14,
        lineHeight: 20,
        letterSpacing: 0.01
    },
    16: {
        fontSize: 16,
        lineHeight: 24,
        letterSpacing: 0.01
    },
    18: {
        fontSize: 18,
        lineHeight: 28,
        letterSpacing: 0.01
    },
    24: {
        fontSize: 24,
        lineHeight: 36,
        letterSpacing: 0
    },
    32: {
        fontSize: 32,
        lineHeight: 40,
        letterSpacing: 0
    },
    48: {
        fontSize: 48,
        lineHeight: 64,
        letterSpacing: -0.01
    },
    72: {
        fontSize: 72,
        lineHeight: 92,
        letterSpacing: -0.02
    }
};
var baseStyle = styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n  white-space: pre-line;\n  ", "\n"], ["\n  margin: 0;\n  white-space: pre-line;\n  ",
    "\n"])), function (props) { return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    ", "\n  ", "\n  font-weight: ", ";\n    ", "\n    ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  "], ["\n    ", "\n    ", "\n  ", "\n  font-weight: ", ";\n    ",
    "\n    ", "\n  ", "\n  ",
    "\n  ",
    "\n  ",
    "\n  "])), breakpoints_1.bp.each("font-size", props.fontSize, "px"), breakpoints_1.bp.each("line-height", props.lineHeight, "px"), breakpoints_1.bp.each("letter-spacing", props.letterSpacing, "em"), props.bold ? "bold" : "normal", props.underline
    ? "text-decoration: underline;"
    : props.underline === false
        ? "text-decoration: none;"
        : "", props.color ? "color: " + props.color + ";" : "", props.align ? "text-align: " + props.align + ";" : "", props.lines
    ? breakpoints_1.bp.each("height", props.lineHeight, "px", function (x) { return x * Number(props.lines); })
    : "", props.lines === 1
    ? "\n  width: 100%;\n  min-width: 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  "
    : "", props.loading
    ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          width: ", ";\n          ", "\n          color: transparent;\n          position: relative;\n          user-select: none;\n          &:before {\n            content: \"x\";\n            background-color: ", ";\n            position: absolute;\n            ", "\n            left: 0;\n            ", "\n            max-width: 100%;\n            width: ", ";\n            border-radius: 3px;\n            pointer-events: none;\n            ", "\n          }\n        "], ["\n          width: ", ";\n          ",
        "\n          color: transparent;\n          position: relative;\n          user-select: none;\n          &:before {\n            content: \"x\";\n            background-color: ", ";\n            position: absolute;\n            ", "\n            left: 0;\n            ", "\n            max-width: 100%;\n            width: ",
        ";\n            border-radius: 3px;\n            pointer-events: none;\n            ", "\n          }\n        "])), props.loaderChars ? props.loaderChars * 0.5 + "em" : "100%", breakpoints_1.bp.each("height", props.lineHeight, "px", function (x) { return x * (props.lines || 1); }), colors_1.default.shade[5], breakpoints_1.bp.each("top", props.lineHeight, "px", function (x) { return x * 0.15; }), breakpoints_1.bp.each("height", props.lineHeight, "px", function (x) { return x * 0.7; }), props.loaderChars
        ? props.loaderChars * 0.5 + "em"
        : "100%", props.noPulse ? "" : mixins_1.loadingPulseAnimation) : ""); });
var Base = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"
    // this should be "keyof JSX.IntrinsicElement" but that breaks TS because of a bug
])), baseStyle);
function getSizeProps(size) {
    if (!size)
        return sizes[16];
    if (typeof size === "object") {
        return {
            fontSize: mapValues_1.default(size, function (x) { return sizes[x].fontSize; }),
            lineHeight: mapValues_1.default(size, function (x) { return sizes[x].lineHeight; }),
            letterSpacing: mapValues_1.default(size, function (x) { return sizes[x].letterSpacing; })
        };
    }
    else {
        return sizes[size];
    }
}
var Text = function (props) {
    var tag = props.tag, size = props.size, rest = __rest(props, ["tag", "size"]);
    var sizeProps = react_1.default.useMemo(function () { return getSizeProps(size); }, [size]);
    var baseProps = __assign(__assign({ as: tag }, sizeProps), rest);
    return react_1.default.createElement(Base, __assign({}, baseProps));
};
// ---- hacky workaround to get Text styles and React Router Link working together ----
// ---- preferably DO NOT import this anywhere except components/Link -----------------
// const TextLinkBase = styled(Link as Link<{} | null | undefined>)`
//   ${baseStyle}
// `
var TextLinkBase = styled_components_1.default(function (props) {
    var Comp = react_router_dom_1.Link;
    // filter style props from reaching DOM
    var bold = props.bold, color = props.color, underline = props.underline, lines = props.lines, fontSize = props.fontSize, lineHeight = props.lineHeight, letterSpacing = props.letterSpacing, loading = props.loading, loaderChars = props.loaderChars, rest = __rest(props, ["bold", "color", "underline", "lines", "fontSize", "lineHeight", "letterSpacing", "loading", "loaderChars"]);
    return react_1.default.createElement(Comp, __assign({}, rest));
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), baseStyle);
var TextLink = function (props) {
    var size = props.size, rest = __rest(props, ["size"]);
    var sizeProps = react_1.default.useMemo(function () { return getSizeProps(size); }, [size]);
    var baseProps = __assign(__assign({}, sizeProps), rest);
    return react_1.default.createElement(TextLinkBase, __assign({}, baseProps));
};
exports.TextLink = TextLink;
// ---- end hacky workaround
exports.default = react_1.default.memo(Text);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
